// Períodos do plano: o cálculo é sempre mês a mês (12 posições, jan..dez) e as quebras
// Anual / Trimestral / Mensal só agrupam meses para exibição e edição.

export const MONTH_LABELS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
export const MONTH_INDEXES = Object.freeze([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);

export const GRANULARITY = Object.freeze({
  ANUAL: 'anual',
  TRIMESTRAL: 'trimestral',
  MENSAL: 'mensal',
});

export const GRANULARITY_OPTIONS = [
  { value: GRANULARITY.ANUAL, label: 'Anual' },
  { value: GRANULARITY.TRIMESTRAL, label: 'Trimestral' },
  { value: GRANULARITY.MENSAL, label: 'Mensal' },
];

export const normalizeGranularity = (value) => {
  const v = String(value || '').toLowerCase();
  if (v === GRANULARITY.TRIMESTRAL || v === GRANULARITY.MENSAL) return v;
  return GRANULARITY.ANUAL;
};

/** Colunas de período para a quebra: { key, label, months: [índices 0..11] }. */
export const periodsFor = (granularity, planYear) => {
  const g = normalizeGranularity(granularity);
  const yy = planYear ? `/${String(planYear).slice(-2)}` : '';
  if (g === GRANULARITY.MENSAL) {
    return MONTH_INDEXES.map((m) => ({ key: `M${m + 1}`, label: `${MONTH_LABELS[m]}${yy}`, months: [m] }));
  }
  if (g === GRANULARITY.TRIMESTRAL) {
    return [0, 1, 2, 3].map((q) => ({ key: `T${q + 1}`, label: `T${q + 1}`, months: [q * 3, q * 3 + 1, q * 3 + 2] }));
  }
  return [{ key: 'ANO', label: planYear ? String(planYear) : 'Ano', months: [...MONTH_INDEXES] }];
};

export const zeros12 = () => new Array(12).fill(0);

export const sumMonths = (series, months = MONTH_INDEXES) => {
  let total = 0;
  for (const m of months) total += Number(series?.[m]) || 0;
  return total;
};

export const addInto = (target, source) => {
  for (let i = 0; i < 12; i += 1) target[i] += Number(source?.[i]) || 0;
  return target;
};

/** "2026-03" -> { year: 2026, month: 3 } */
export const parseMonthKey = (key) => {
  const match = String(key || '').match(/^(\d{4})-(\d{2})/);
  if (!match) return null;
  return { year: Number(match[1]), month: Number(match[2]) };
};

export const toMonthKey = (year, month) => `${year}-${String(month).padStart(2, '0')}`;

export const monthOrdinal = ({ year, month }) => year * 12 + (month - 1);

export const fromOrdinal = (ordinal) => ({ year: Math.floor(ordinal / 12), month: (ordinal % 12) + 1 });

export const shortMonthLabel = ({ year, month }) => `${MONTH_LABELS[month - 1].toLowerCase()}/${String(year).slice(-2)}`;

/** Lista de meses entre dois "yyyy-MM" (inclusivo). */
export const monthRange = (startKey, endKey) => {
  const start = parseMonthKey(startKey);
  const end = parseMonthKey(endKey);
  if (!start || !end) return [];
  const out = [];
  for (let o = monthOrdinal(start); o <= monthOrdinal(end); o += 1) out.push(fromOrdinal(o));
  return out;
};
